







































































































import { Component, Vue } from 'vue-property-decorator';
import AppStore from '@/store/App';

@Component({})
export default class CoreFilter extends Vue {
  colors = [
    'primary',
    'info',
    'success',
    'warning',
    'danger'
  ];

  images = [
    'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-1.23832d31.jpg',
    'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg',
    'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-3.3a54f533.jpg',
    'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-4.3b7e38ed.jpg'
  ];

  get image() { return AppStore.image; }
  get color() { return AppStore.color; }
  setImage( val: string ) { AppStore.SET_IMAGE(val); }
  setColor( val: string ) { AppStore.SET_COLOR(val); }
}
